import React from 'react';
import Card from 'components/common/Card';
import SelectSearch from 'react-select-search';

import config from 'config';

import {
  Button,
  FlexItem,
  HeaderText,
  FlexContain,
  FilterText,
  ButtonBase,
  SearchInput,
  FiltersCard,
  FilterInkBar,
  ButtonLabel,
  EmptyMessage,
  SearchContain,
  FiltersContain,
  HeadersContain,
  OrdersContainer,
  FilterContainer,
  FiltersContainer,
  StatusFilterContain
} from './OrdersStyled';

import OrderListItem from './OrderListItem';
import {
  PENDING,
  INVALID,
  FORM1,
  STRATA,
  COMPLETE,
  IN_PROGRESS,
  FILTER_BY_FILE,
  COUNCIL_SEARCH,
  FILTER_BY_ADDRESS
} from 'constants/orders';

const FILTERS = [false, PENDING, IN_PROGRESS, COMPLETE, INVALID];

const SEARCH_OPTIONS = [
  { name: 'Address', value: FILTER_BY_ADDRESS },
  { name: 'File', value: FILTER_BY_FILE }
];

function renderStateBadges (supportStates = []) {
  return supportStates.map((state) => 
    <span style={{ 
      background:   '#00000024', 
      padding:      '0.15rem 0.375rem', 
      borderRadius: '0.375rem', 
      marginLeft:   '0.25rem', 
      fontSize:     '12px', 
      fontWeight:   400, 
      color:        '#ffffff' 
    }}>
    {state.toUpperCase()}
    </span>
  )
}

export const Orders = ({
  beta,
  orders,
  onSearch,
  onSearchBy,
  activeQueryBy,
  activeQuery,
  onOrderClick,
  activeFilter,
  createForm1,
  createSearch,
  createStrata,
  onFilterClick,
  renderPagination
}) => {
  return (
    <OrdersContainer>
      <FiltersContainer>
        <FlexContain>
          <FlexContain>
            <Button onClick={createSearch}>
              <ButtonLabel style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ marginRight: '0.25rem' }}><span style={{ fontSize: '1rem' }}>+</span> Council Search</span>
                {renderStateBadges(config.features[COUNCIL_SEARCH].states)}
              </ButtonLabel>
            </Button>

            <Button onClick={createStrata} style={{ marginLeft: '0.5em' }}>
              <ButtonLabel style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ marginRight: '0.25rem' }}><span style={{ fontSize: '1rem' }}>+</span> Strata Search</span>
                {renderStateBadges(config.features[STRATA].states)}
              </ButtonLabel>
            </Button>

            <Button onClick={createForm1} style={{ marginLeft: '0.5em' }}>
              <ButtonLabel style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ marginRight: '0.25rem' }}><span style={{ fontSize: '1rem' }}>+</span> Form 1</span>
                {renderStateBadges(config.features[FORM1].states)}
              </ButtonLabel>
            </Button>
          </FlexContain>
        </FlexContain>
      </FiltersContainer>

      <FiltersCard>
        <FilterContainer>
          <StatusFilterContain>
            <Filters activeFilter={activeFilter} onFilterClick={onFilterClick} />
          </StatusFilterContain>

          <div style={{ display: 'flex', flex: 1 }}>
            <div style={{ flex: 1 }} />
            <SearchOrders
              onSearch={onSearch}
              onSearchBy={onSearchBy}
              activeQuery={activeQuery}
              activeQueryBy={activeQueryBy}
            />
          </div>
        </FilterContainer>
      </FiltersCard>

      <Card.Content>
        <ListHeaders />
        {!orders.length && (
          <EmptyOrdersMessage
            activeFilter={activeFilter}
            activeQuery={activeQuery}
          />
        )}

        <OrdersList
          orders={orders}
          renderItem={(order, index) => (
            <OrderListItem
              onClick={onOrderClick}
              secondary={index % 2}
              key={order.id}
              {...order}
            />
          )}
        />
        {renderPagination()}
      </Card.Content>
    </OrdersContainer>
  );
};

Orders.defaultProps = {
  orders: [],
  renderPagination: () => null
};

const OrdersList = ({ orders, renderItem }) =>
  orders.map((order, index) => renderItem(order, index));

const ListHeaders = () => (
  <HeadersContain>
    <FlexItem maxWidth={480} flex={2}>
      <HeaderText>Address</HeaderText>
    </FlexItem>
    <FlexItem paddingLeft={32} maxWidth={200}>
      <HeaderText>File</HeaderText>
    </FlexItem>
    <FlexItem>
      <HeaderText>Created Date</HeaderText>
    </FlexItem>
    <FlexItem>
      <HeaderText>Council</HeaderText>
    </FlexItem>
    <FlexItem>
      <HeaderText>Urgency</HeaderText>
    </FlexItem>
    <FlexItem>
      <HeaderText>Status</HeaderText>
    </FlexItem>
  </HeadersContain>
);

const EmptyOrdersMessage = ({ activeQuery, activeFilter }) => {
  return (
    <EmptyMessage>
      {activeQuery || activeFilter
        ? 'No Orders Found'
        : 'You currently have no orders.'}
    </EmptyMessage>
  );
};

const SearchOrders = ({ onSearch, activeQuery, activeQueryBy, onSearchBy }) => {
  return (
    <SearchContain>
      <FlexItem justify="flex-end">
        <SearchInput
          removeRightBorderRadius
          name="search-orders"
          value={activeQuery}
          onChange={onSearch}
        />
        <div style={{ width: 150 }}>
          <SelectSearch
            search={false}
            name="search-orders"
            placeholder="Search By"
            value={activeQueryBy}
            options={SEARCH_OPTIONS}
            onChange={({ value }) => onSearchBy(value)}
          />
        </div>
      </FlexItem>
    </SearchContain>
  );
};

const Filters = ({ onFilterClick, activeFilter }) => (
  <React.Fragment>
    <FiltersContain>
      <FlexItem>
        <ButtonBase onClick={onFilterClick.bind(null, false)}>
          <FilterText>All</FilterText>
        </ButtonBase>
      </FlexItem>
      <FlexItem>
        <ButtonBase onClick={onFilterClick.bind(null, PENDING)}>
          <FilterText>Pending</FilterText>
        </ButtonBase>
      </FlexItem>
      <FlexItem>
        <ButtonBase onClick={onFilterClick.bind(null, IN_PROGRESS)}>
          <FilterText>In Progress</FilterText>
        </ButtonBase>
      </FlexItem>
      <FlexItem>
        <ButtonBase onClick={onFilterClick.bind(null, COMPLETE)}>
          <FilterText>Completed</FilterText>
        </ButtonBase>
      </FlexItem>
      <FlexItem>
        <ButtonBase onClick={onFilterClick.bind(null, INVALID)}>
          <FilterText>Invalid</FilterText>
        </ButtonBase>
      </FlexItem>
    </FiltersContain>
    <FilterInkBar count={5} selected={FILTERS.indexOf(activeFilter)} />
  </React.Fragment>
);

export default Orders;
